import { render, staticRenderFns } from "./Bell.vue?vue&type=template&id=2d4c7e40&scoped=true"
import script from "./Bell.vue?vue&type=script&lang=js"
export * from "./Bell.vue?vue&type=script&lang=js"
import style0 from "./Bell.vue?vue&type=style&index=0&id=2d4c7e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c7e40",
  null
  
)

export default component.exports